<template>
  <div class="content content_in">
    <div class="title-row d-flex row justify-content-between">
      <div class="col-12 d-flex w-100 col-md-auto">
        <h1 class="w-100">{{ $t("faq.caption") }}</h1>
        <a :href="telegramLink" class="btn" target="_blank">{{ $t("faq.ask_question") }}</a>
      </div>
    </div>

    <FormatList :tabs="formats" :currentTab="currentFormat" :textPath="'faq.tabs'" @setCurrentTab="setCurrentTab" class="mb-4" />

    <div class="tabs-content">
      <div class="tabs-content__item active">
        <div class="faq">
          <div class="faq__item" v-for="(item, idx) in activeFaqItems" :key="idx">
            <div class="faq__question" role="button" :class="{ active: isActive(idx) }" @click="toggleItem(idx)">
              {{ $t(item.question) }}
            </div>

            <div class="faq__answer entry-content" v-show="isActive(idx)" v-html="$t(item.answer)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormatList from "@/components/FormatList.vue";
import { mapGetters } from "vuex";

export default {
  name: "FAQ",
  components: { FormatList },

  data() {
    return {
      formats: ["general_questions", "finance_questions", "technical_questions", "push", "inpage", "onclick"],
      currentFormat: "general_questions",
      openIndex: {},
    };
  },

  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    activeFaqItems() {
      const currentLocale = this.$i18n.locale;

      const path = `faq.items.${this.currentFormat}`;
      const items = this.$i18n.getLocaleMessage(currentLocale)[path] || this.$t(path) || [];

      return items;
    },

    telegramLink() {
      const url = `https://t.me/${this.user.manager.telegram}`.replace("@", "");
      return url;
    },
  },

  methods: {
    setCurrentTab(tabKey) {
      this.currentFormat = tabKey;

      this.$router.replace({ query: { ...this.$route.query, format: tabKey } }).catch(() => {});
    },

    isActive(idx) {
      return this.openIndex[this.currentFormat] === idx;
    },

    toggleItem(idx) {
      const key = this.currentFormat;
      const current = this.openIndex[key];
      this.$set(this.openIndex, key, current === idx ? null : idx);
    },

    initFormatFromQuery() {
      const queryFormat = this.$route.query.format;

      if (queryFormat && this.formats.includes(queryFormat)) {
        this.currentFormat = queryFormat;
      }
    },
  },

  created() {
    this.formats.forEach((key) => {
      this.$set(this.openIndex, key, null);
    });

    this.initFormatFromQuery();
  },
};
</script>

<style lang="scss">
.tabs-content__item {
  display: none;
  &.active {
    display: block;
  }
}

.faq__item {
  background: #f7f7f9;
  border-radius: 5px;
  margin-bottom: 10px;
}

.faq__question {
  font-weight: 700;
  font-size: 16px;
  padding: 20px 60px 20px 30px;
  cursor: pointer;
  transition: 0.3s;
  position: relative;

  @media (max-width: 767px) {
    padding-left: 20px;
  }

  &:before {
    content: "";
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid #000;
    opacity: 0.3;
    transition: 0.3s;
  }

  &.active:before {
    transform: translateY(-50%) scale(1, -1);
    opacity: 1;
  }
}

.faq__answer {
  padding: 0 30px 20px;
  max-width: 770px;

  p:last-child {
    margin-bottom: 0 !important;
  }

  @media (max-width: 767px) {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
